/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'navigation';
const componentName = 'avi-skip-link';
const prefix = `${moduleName}.${componentName}`;

export const skipToMainContent = `${prefix}.skipToMainContent`;

export const ENGLISH = {
    [skipToMainContent]: 'Skip to main content',
};
